// extracted by mini-css-extract-plugin
module.exports = {"navContent":"TheNavigation_navContent_2ObFi","navigation":"TheNavigation_navigation_Iik6o","appName":"TheNavigation_appName_2Rv81"};